import { React } from 'react';
import {
  SidebarQuarterlyContainer,
  AccordionTitle,
  AccordionContent,
  AccordionContentFuture,
  AccordionText,
  OrangeColorStyle,
  RowStyle,
  LegendTextStyle,
} from '@atoms/sidebar/sidebar.styles';
import Legend from '@molecules/pursuitLeader/components/legend';
import MontlySideBar from '@molecules/pursuitLeader/components/montlySideBar';
import flagOutline from '@assets/icons/flagOutline.png';
import { formatNumberWithKAndM } from '@util/commonUtil';

const QuarterlyPastExpandedSidebar = ({ data, quarter, expanded, toggleAccordion, propsData }) => {
  return (
    <SidebarQuarterlyContainer className={expanded ? 'expanded' : 'collapsed'}>
      <AccordionTitle style={{ padding: '15px 0px 15px 15px' }} onClick={toggleAccordion}>
        <h3>{`${quarter} | FY${data?.quarterlyCalculation?.selected_year}`}</h3>
      </AccordionTitle>

      {!!data && data['quarterlyCalculation']?.period === 'past' ? (
        <AccordionContent>
          <Legend quarterlyData={data['quarterlyCalculation']} quarterText={quarter} />
          <AccordionText style={{ color: '#ffffff' }}>
            Uncommitted Pipeline:{' '}
            {formatNumberWithKAndM(data['quarterlyCalculation']?.noCommit) || 0}
          </AccordionText>
        </AccordionContent>
      ) : null}

      {!!data && data['quarterlyCalculation']?.period === 'future' ? (
        <AccordionContentFuture>
          <img src={flagOutline} alt=" " />
          <span>{formatNumberWithKAndM(data['quarterlyCalculation']?.commit) || 0}</span>
          <RowStyle>
            <OrangeColorStyle />
            <LegendTextStyle>Commit</LegendTextStyle>
          </RowStyle>
          <AccordionText style={{ color: '#ffffff' }}>
            No Commit: {formatNumberWithKAndM(data['quarterlyCalculation']?.noCommit) || 0}
          </AccordionText>
        </AccordionContentFuture>
      ) : null}

      {data ? <MontlySideBar quarterData={data} propsData={propsData} /> : null}
    </SidebarQuarterlyContainer>
  );
};

export default QuarterlyPastExpandedSidebar;
